import { render } from "./GameGenerator.vue?vue&type=template&id=7745930c&ts=true"
import script from "./GameGenerator.vue?vue&type=script&lang=ts"
export * from "./GameGenerator.vue?vue&type=script&lang=ts"

import "./GameGenerator.vue?vue&type=style&index=0&id=7745930c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__